import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import {Select, TextField} from 'redux-form-material-ui';
import {Button, InputLabel, MenuItem} from "material-ui";
import Grid from 'material-ui/Grid';
import Paper from 'material-ui/Paper';
import Typography from 'material-ui/Typography';
import {Validator} from '../../core/Validator';
import { InputAdornment } from 'material-ui/Input';

const validate = values => Validator.build(values, {
    'name': [Validator.required],
    'price': [Validator.required, Validator.int],
    'location': [Validator.required],
    'category': [Validator.required]
});

class ItemForm extends Component {
    render(){
        return (
            <Paper elevation={4} style={{padding: '16px 8px'}}>
                <Typography variant="headline" component="h3">
                    Create a new item
                </Typography>
                <form onSubmit={this.props.handleSubmit}>
                    <Grid container>
                        <Grid item md={4}>
                            <Field
                                name="name"
                                fullWidth={true}
                                component={TextField}
                                label="Nom de l'objet"
                            />
                        </Grid>
                        <Grid item md={4}>
                            <Field
                                name="price"
                                fullWidth={true}
                                component={TextField}
                                label="Prix"
                                inputProps={{
                                    endAdornment: <InputAdornment position="end">Kg</InputAdornment>
                                }}
                            />
                        </Grid>
                        <Grid item md={4}>
                            <Field
                                name="location"
                                fullWidth={true}
                                component={TextField}
                                label="Localisation"
                            />
                        </Grid>
                        <Grid item md={4}>
                            <InputLabel htmlFor="category">Catégorie</InputLabel>
                            <Field
                                name="category"
                                fullWidth={true}
                                component={Select}
                                label="Type"
                                inputProps={{
                                    name: 'category',
                                    id: 'category',
                                }}
                            >
                                <MenuItem value="2hand">Arme à 2 mains</MenuItem>
                                <MenuItem value="1hand">Arme à 1 mains</MenuItem>
                                <MenuItem value="helm">Casque</MenuItem>
                                <MenuItem value="chest">Armure</MenuItem>
                                <MenuItem value="shield">Bouclier</MenuItem>
                            </Field>
                        </Grid>
                        <Grid item md={4}>
                            <Field
                                name="required_lvl"
                                fullWidth={true}
                                component={TextField}
                                label="Niveau requis"
                            />
                        </Grid>
                        <Grid item md={4}>
                            <Field
                                name="strength_required"
                                fullWidth={true}
                                component={TextField}
                                label="Force requise"
                            />
                        </Grid>
                        <Grid item md={4}>
                            <Field
                                name="dexterity_required"
                                fullWidth={true}
                                component={TextField}
                                label="Dextérité requise"
                            />
                        </Grid>
                        <Grid item md={4}>
                            <Field
                                name="armor_required"
                                fullWidth={true}
                                component={TextField}
                                label="Armure requise"
                            />
                        </Grid>
                        <Grid item md={12}>
                            <Button type="submit" variant="raised" color={"primary"}>Sauvegarder</Button>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
        )
    }
};

export default reduxForm({
    form: 'itemForm',
    validate
})(ItemForm);


// WEBPACK FOOTER //
// ./src/pages/items/ItemForm.js